import type { Phase } from '../lib/session.ts';
import { Icon } from './Icon.tsx';

interface ControlsProps {
  phase: Phase;
  micEnabled: boolean;
  camEnabled: boolean;
  canReport: boolean;
  unreadChat: boolean;
  onToggleMic: () => void;
  onToggleCam: () => void;
  onStartStop: () => void;
  onReport: () => void;
  onToggleChat: () => void;
  onNext: () => void;
}

export function Controls(props: ControlsProps) {
  const idle = props.phase === 'idle';
  const micLabel = props.micEnabled ? 'Mikrofon stumm' : 'Mikrofon an';
  const camLabel = props.camEnabled ? 'Kamera aus' : 'Kamera an';
  const startStopLabel = idle ? 'Suche starten' : 'Suche anhalten';

  return (
    <footer className="controls">
      <div className="dock">
        <button
          type="button"
          className={`control${props.micEnabled ? '' : ' control--off'}`}
          onClick={props.onToggleMic}
          aria-label={micLabel}
          title={micLabel}
        >
          <Icon name={props.micEnabled ? 'mic' : 'micOff'} />
        </button>
        <button
          type="button"
          className={`control${props.camEnabled ? '' : ' control--off'}`}
          onClick={props.onToggleCam}
          aria-label={camLabel}
          title={camLabel}
        >
          <Icon name={props.camEnabled ? 'cam' : 'camOff'} />
        </button>
        <button
          type="button"
          className="control"
          onClick={props.onStartStop}
          aria-label={startStopLabel}
          title={startStopLabel}
        >
          <Icon name={idle ? 'play' : 'stop'} />
        </button>
        <span className="dock__divider" aria-hidden="true" />
        <button
          type="button"
          className="control control--report"
          onClick={props.onReport}
          disabled={!props.canReport}
          aria-label="Person melden"
          title="Person melden"
        >
          <Icon name="flag" />
        </button>
        <button
          type="button"
          className="control control--chat"
          onClick={props.onToggleChat}
          aria-label="Chat"
          title="Chat"
        >
          <Icon name="chat" />
          {props.unreadChat && <span className="control__dot" />}
        </button>
      </div>

      <button
        type="button"
        className="next-button"
        onClick={props.onNext}
        disabled={props.phase === 'searching'}
      >
        <span>{idle ? 'Los geht’s' : 'Weiter'}</span>
        <span className="next-button__arrow">
          <Icon name="next" />
        </span>
        <kbd aria-hidden="true">→</kbd>
      </button>
    </footer>
  );
}
